import { createSlice } from "@reduxjs/toolkit";
import { fetch as fetchProductGroupsApi } from "services/product-groups.service";

const ProductGroupsSlice = createSlice({
  name: "productGroups",
  initialState: {
    productGroupsCollection: [],
    isLoading: false,
    isError: false,
    errMsg: null,
    filtersValue: {
      textSearch: "",
    },
  },
  /* eslint-disable no-param-reassign */
  reducers: {
    setLoading(state) {
      state.isLoading = true;
      state.isError = false;
    },
    setProductGroups(state, action) {
      state.isLoading = false;
      state.productGroupsCollection = action.payload.productGroupsCollection;
    },
    setError(state, action) {
      state.isError = true;
      state.errMsg = action.payload.errMsg;
      state.isLoading = false;
    },
    setFilterValue(state, action) {
      const { key, value } = action.payload;
      state.filtersValue[key] = value;
    },
  },
  /* eslint-enable */
});

const { actions, reducer } = ProductGroupsSlice;

export const { setLoading, setProductGroups, setError, setFilterValue } =
  actions;

export default reducer;

export const fetchProductGroups =
  (companyId, filtersValue) => async (dispatch) => {
    dispatch(setLoading());
    try {
      const { productGroupsCollection } = await fetchProductGroupsApi(
        companyId,
        filtersValue
      );
      dispatch(setProductGroups({ productGroupsCollection }));
    } catch (e) {
      dispatch(setError({ errMsg: "" }));
    }
  };


